<section class="content">
    <section class="company-intro-section">
        <p class="typography-title-l">{{ 'my_profile.user_section.title' | translate }}</p>
        <p class="typography-title-s description">{{ 'my_profile.user_section.title_description' | translate }}</p>
    </section>

    <section class="company-form">
        <section class="company-intro">
            <p class="typography-title-m">{{ 'my_profile.user_section.title_user_data' | translate }}</p>
        </section>

        <section class="company-atts">
            <form class="company-atts-form">
                <div class="company-atts-row">
                    <div class="form-group">
                        <label for="name">{{ 'my_profile.user_section.firstname' | translate }}</label>
                        <input
                            type="text"
                            id="name"
                            name="name"
                            [(ngModel)]="name"
                            [placeholder]="'my_profile.user_section.first_name_placeholder' | translate"
                            (ngModelChange)="checkForChanges()"
                            aria-label="name"
                        />
                    </div>

                    <div class="form-group">
                        <label for="lastname">{{ 'my_profile.user_section.lastname' | translate }}</label>
                        <input
                            type="text"
                            id="lastname"
                            name="lastname"
                            [(ngModel)]="lastName"
                            [placeholder]="'my_profile.user_section.lastname_placeholder' | translate"
                            (ngModelChange)="checkForChanges()"
                            aria-label="lastname"
                        />
                    </div>
                </div>
                <div class="company-atts-row">
                    <div class="form-group">
                        <label for="position">{{ 'my_profile.my_company.position' | translate }}</label>
                        <!-- <app-combobox
                                placeholder="{{ 'my_profile.user_section.position_placeholder' | translate }}"
                                [selectedValue]="position"
                                [options]="getUserPositions()"
                                (change)="selectUserPosition($event)">
                            </app-combobox> -->
                                        <app-select
                                            [small]="true"
                                            placeholder="{{ 'my_profile.user_section.position_placeholder' | translate }}"
                                            [options]="getUserPositions()"
                                            [selectedValue]="selectedPosition"
                                            [required]="false"
                                            [disabled]="false"
                                            [searchable]="false"
                                            (selectedValueChanged)="selectUserPosition($event)"
                                            ></app-select>
                    </div>
                </div>
                <div class="company-atts-row">
                    <div class="form-group">
                        <label for="phone">{{ 'my_profile.my_company.phone' | translate }}</label>
                        <input
                            type="text"
                            id="phone"
                            name="phone"
                            [(ngModel)]="phone"
                            [placeholder]="'my_profile.my_company.phone_placeholder' | translate"
                            (ngModelChange)="checkForChanges()"
                            aria-label="phone"
                        />
                    </div>

                    <div class="form-group">
                        <label for="email">{{ 'my_profile.my_company.email' | translate }}</label>
                        <input
                            type="text"
                            id="email"
                            name="email"
                            [(ngModel)]="email"
                            [placeholder]="'my_profile.my_company.email_placeholder' | translate"
                            (ngModelChange)="checkForChanges()"
                            aria-label="email"
                        />
                    </div>
                </div>
                <span class="typography-body-s-light">{{ 'my_profile.my_company.help_shop_data_text' | translate }}</span>
            </form>
        </section>
    </section>

    <section class="company-form">
        <section class="company-intro">
            <p class="typography-title-m">{{ 'my_profile.my_company.title_user_data' | translate }}</p>
        </section>

        <section class="company-atts flex flex-col">
            <div class="mb-2 flex flex-col gap-4">
                <div class="flex-row flex gap-4 items-center">
                    <app-checkbox-toggle [isChecked]="true" [disabled]="true"></app-checkbox-toggle>
                    <span>{{ 'my_profile.user_section.has_we_access' | translate }}</span>
                </div>
                <div class="flex-row flex gap-4 items-center" *ngIf="userInfo.accountType && ['FABRICATOR', 'INSTALLER'].includes(userInfo.accountType)">
                    <app-checkbox-toggle
                        [isChecked]="hasEcosentinoAccess || false"
                        (onChecked)="onAllowEcosentinoAccess(!hasEcosentinoAccess)"
                        [disabled]="userInfo.role != 'ADMIN'"
                    ></app-checkbox-toggle>
                    <span>{{ 'my_profile.user_section.has_ecosentino_access' | translate }}</span>
                </div>
                <div class="flex-row flex gap-4 items-center" *ngIf="userInfo.accountType && ['FABRICATOR', 'INSTALLER'].includes(userInfo.accountType)">
                    <app-checkbox-toggle
                        [isChecked]="hasFinancialPortalAccess || false"
                        (onChecked)="onAllowFinancialPortalAccess(!hasFinancialPortalAccess)"
                        [disabled]="userInfo.role != 'ADMIN'"
                    ></app-checkbox-toggle>
                    <span>{{ 'my_profile.user_section.has_financial_portal_access' | translate }}</span>
                </div>
                <div class="flex-row flex gap-4 items-center" *ngIf="userInfo.accountType && ['FABRICATOR', 'RETAIL'].includes(userInfo.accountType) && userInfo.isActiveNexusProgram">
                    <app-checkbox-toggle
                        [isChecked]="hasNexusAccess || false"
                        (onChecked)="onAllowNexusAccess(!hasNexusAccess)"
                        [disabled]="userInfo.role != 'ADMIN'"
                    ></app-checkbox-toggle>
                    <span>{{ 'my_profile.user_section.has_nexus_access' | translate }}</span>
                </div>
                <div class="flex-row flex gap-4 items-center" *ngIf="userInfo.accountType && ['FABRICATOR', 'RETAIL'].includes(userInfo.accountType) && userInfo.isActiveLeadsB2C" >
                    <app-checkbox-toggle [isChecked]="notificationsFromLeads || false" (onChecked)="onAllowNotificationsFromLeads(!notificationsFromLeads)"></app-checkbox-toggle>
                    <span>{{ 'my_profile.user_section.notifications_from_leads' | translate }}</span>
                </div>
            </div>
        </section>
    </section>

    <section class="company-save-button">
        <div class="buttonsSection primaryDefault">
            <app-button class="w-full md:w-auto" [skin]="'we'" [primary]="true" [size]="'medium'" [disabled]="!hasChanges" (onClick)="onSaveAll()" data-id="buttonId">
                <span>{{ 'my_profile.my_company.save_button' | translate }}</span>
            </app-button>
        </div>
    </section>
</section>
